import RangeSliderContainer from "../../../Components/BonusUi/RangeSlider/RangeSliderContainer";

const RangeSlider = () => {
  return <RangeSliderContainer />;
};

export default RangeSlider;
